/**
 * @description Gestion du sommaire
 */

/* global bsBreakpoints $toggle */

(() => {
	// VARS
	const root = document.querySelector('[data-selector-page-summary]');
	const jobPage = document.querySelector('.page-job') || null;
	let allH2;
	// Condition pour offre d'emploi, ajout du h2 du bloc summary-job dans le sommaire
	if (jobPage) {
		allH2 = jobPage.querySelectorAll('h2');
	}
	// Si  !page offre emploi alors on selectionne les H2 des .a-edito
	else {
		allH2 = document.querySelector('.a-edito').querySelectorAll('h2');
	}
	let hasH2 = true;
	if (allH2.length === 0) {
		hasH2 = false;
	}
	const hasCalendar = document.querySelector('#event-calendar');

	const $ = {
		toggle: 'data-page-summary-title',
		content: 'data-page-summary-content',
		figcaption: 'data-js-figcaption',
	};

	// Fonctions
	const addID = (el) => {
		let index = 1;

		el.forEach((item) => {
			item.id = `h2-${index}`;

			if (item.offsetTop === 0) {
				item.setAttribute(
					'data-title-position',
					item.parentElement.offsetTop
				);
			} else {
				item.setAttribute('data-title-position', item.offsetTop);
			}

			index++;
		});
	};

	const toggle = () => {
		root.querySelector(`[${$.toggle}]`).addEventListener('click', () => {
			const el = root.querySelector(`[${$.content}]`);
			const chevron = root.querySelector(`[${$.toggle}]`);

			if (chevron.getAttribute('data-toggle-status') === 'active') {
				chevron.setAttribute('data-toggle-status', 'inactive');
				el.classList.add('active');
				if (
					bsBreakpoints.detectBreakpoint() === 'small' ||
					bsBreakpoints.detectBreakpoint() === 'xSmall'
				) {
					root.classList.remove('open');
					document.querySelector('body').classList.remove('fixed');
				}
			} else {
				chevron.setAttribute('data-toggle-status', 'active');
				el.classList.remove('active');
				if (
					bsBreakpoints.detectBreakpoint() === 'small' ||
					bsBreakpoints.detectBreakpoint() === 'xSmall'
				) {
					root.classList.add('open');
					document.querySelector('body').classList.add('fixed');
				}
			}

			$toggle(el, 'block');
		});
	};

	const constructSummary = (el) => {
		let content = `<div class="page-summary-card card">
                        <div class="page-summary__title card-header" data-page-summary-title>Sommaire<i data-icon="chevron" aria-hidden="true"></i></div>
                        <ul class="page-summary__content card-body" data-page-summary-content>`;

		el.forEach((item) => {
			content += `<li class="page-summary__content__link" data-position="${item.getAttribute(
				'data-title-position'
			)}">
			
				<div class="page-summary__content__section">
					<span class="page-summary__content__link__puce"></span><a class="stretched-link" href="#${
						item.id
					}" data-dot="3">${item.innerText}</a>
				</div>
				<div class="page-summary__content__separate"></div>		
			</li>`;
		});

		content += `</ul></div>`;

		root.innerHTML = content;
	};

	/* Gestion classe active sur elements du sommaire */

	const moveInPage = () => {
		const liTitle = root.querySelectorAll('.page-summary__content__link');
		document.addEventListener('scroll', () => {
			liTitle.forEach((item) => {
				item.classList.add('active');
				if (item.getAttribute('data-position') >= window.pageYOffset) {
					item.classList.remove('active');
				}
			});
		});
	};

	/* --------------------------------------------------- */

	const editMargin = () => {
		if (
			bsBreakpoints.detectBreakpoint() === 'xLarge' ||
			bsBreakpoints.detectBreakpoint() === 'large'
		) {
			let summaryHeight = root.getBoundingClientRect();
			// eslint-disable-next-line no-unused-vars
			summaryHeight = summaryHeight.height;

			root.classList.add('page-summary--sticky');
			root.addEventListener('click', () => {
				let summaryHeight = root.getBoundingClientRect();
				// eslint-disable-next-line no-unused-vars
				summaryHeight = summaryHeight.height;
			});
		} else {
			root.classList.remove('page-summary--sticky');
			document.querySelector('.a-edito').setAttribute('style', '');
		}

		if (document.body.contains(hasCalendar)) {
			root.classList.remove('col-lg-3');
			root.classList.add('page-summary--hasCalendar');
			root.parentElement.classList.remove('row');
			document.querySelector('.a-edito').setAttribute('style', '');
		}
	};

	// add margin top when click on a anchor, prevent title to be hidden by the header
	const anchorMargin = () => {
		// Captures click events of all <a> elements with href starting with #
		document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
			anchor.addEventListener('click', (e) => {
				// Click events are captured before hashchanges. Timeout
				// causes offsetAnchor to be called after the page jump.
				e.preventDefault();
				const h2 = document.querySelector(anchor.getAttribute('href'));
				const header = document.querySelector('.header');
				const topPos =
					h2.getBoundingClientRect().top +
					window.pageYOffset -
					header.offsetHeight -
					100;

				window.scrollTo({
					top: topPos, // scroll so that the element is at the top of the view
					behavior: 'smooth', // smooth scroll
				});
			});
		});
	};

	// GO 🚀
	const init = () => {
		if (document.body.contains(root)) {
			document.body.classList.add('hasSummary');
			root.parentElement.classList.add('row', 'content');

			const contenu = document.querySelector('.row.content').children;

			for (let i = 0; i < contenu.length; i++) {
				const element = contenu[i];

				if (element.classList.contains('a-edito')) {
					element.classList.add('col-lg-9');
				}
			}

			if (document.querySelector('[data-js-figcaption]') !== null) {
				document
					.querySelector('[data-js-figcaption]')
					.classList.add('hasSummary');
			}

			addID(allH2);
			constructSummary(allH2);
		}
		// moveInPage();
		if (document.body.contains(root)) {
			window.onresize = function () {
				editMargin();
				toggle();
			};
			toggle();

			moveInPage();

			document.addEventListener('DOMContentLoaded', () => {
				editMargin();
			});
		}
	};

	if (hasH2) {
		init();
		anchorMargin();
	}
})();
